import * as React from 'react';
import { styled } from 'styled-components';
import leftArrowBrandedBlueSvg from '../../../images/arrow-left-branded-blue.svg';
import { newContentPadding, phoneOnlyMaxWidth, tabletPortraitMinWidth } from '../../cssConstants';

const LeftBlueOrWhiteIcon = ({ onClick, hasLeftMargin = false, className }: Props & { className?: string }) => {
	const arrowIcon = leftArrowBrandedBlueSvg;

	return (
		<LeftIconWrapper onClick={onClick} $hasLeftMargin={hasLeftMargin} className={className}>
			<Img src={arrowIcon} alt="back icon" />
			<StyledSpan>Back</StyledSpan>
		</LeftIconWrapper>
	);
};

export default LeftBlueOrWhiteIcon;

interface Props {
	onClick: () => void;
	hasLeftMargin?: boolean;
}

const LeftIconWrapper = styled.div<{ $hasLeftMargin?: boolean }>`
	display: flex;
	align-items: center;
	cursor: pointer;
	padding: 10px 10px 10px 0;
	margin-left: ${(props) => (props.$hasLeftMargin ? newContentPadding : 0)};
`;

export const LeftBlueOrWhiteIconForModal = styled(LeftBlueOrWhiteIcon)`
	@media (max-width: ${phoneOnlyMaxWidth}) {
		display: none;
	}
`;

export const Img = styled.img`
	width: 20px;
	height: 20px;
`;

const StyledSpan = styled.span`
	display: none;
	font-size: 17px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px;
	letter-spacing: -0.43px;
	color: ${({ theme }) => theme.linkTextColor};

	@media (min-width: ${tabletPortraitMinWidth}) {
		display: block;
	}
`;
